(function (Global, $, _) {
    function UrlParams() {
        var paramsString = Global.location.href.split('?');
        paramsString = paramsString.length > 2 ? paramsString[2] : paramsString[1];

        this.params = (paramsString && paramsString != '') ? this.jsonifyParams(paramsString) : [];
    }

    UrlParams.prototype.jsonifyParams = function (paramsString) {
        var paramStringFirstPass = paramsString.split('&');
        //Parcour l'ensemble des valeurs pour détecter les & ou &amps; qui font partie d'un parametre ( evite de spliter en 2 un param de querrystring juste parce qu'il contient & à l'intérieur)
        for (var i = paramStringFirstPass.length - 1; i >= 0; i--) {
            if (paramStringFirstPass[i].indexOf('=') <= 0 && i - 1 >= 0) {
                paramStringFirstPass[i - 1] = paramStringFirstPass[i - 1] + '&' + paramStringFirstPass[i]; //Ajoute le contenu dans l'element précédent ( car il fait partie du paramêtre précédent)
                paramStringFirstPass[i] = ""; //vide le contenu de l'element courant car ce n'est pas un vrai param de querrystring
            }
        }

        return paramStringFirstPass.map(function (param) {
            var indexSigne = param.indexOf('=');
            if (indexSigne <= 0) return null; // Gestion des cases vide ajouté par la première passe qui regroupe les & sans =

            var p = new Array(2);
            p[0] = param.substr(0, indexSigne); // Permet de récupèrer la partie à gauche du "="
            p[1] = param.substr(indexSigne + 1, param.length - indexSigne - 1); // Permet de récupérer la partie à droite du "=" (attention la partie à droite peux comporter un ou plusieurs "=" faisant partie de la valeur)

            var obj = {};

            obj[decodeURI(p[0])] = decodeURI(p[1]);

            return obj;
        }).filter(function (el) { //Retire les elements vide dans le tableau ( liéà la suppresion de certains param de querrystring incorrectement splités à cause du &)
            return el !== null;
        });
    }
    UrlParams.prototype.getParams = function () {
        var self = this;
        return _.reduce(self.params, function (hash, value) {
            var key = Object.keys(value)[0];

            hash[key] = self.transformValue(value[key]);
            return hash;
        }, {});
    }
    UrlParams.prototype.transformValue = function (value) {
        if (value.split(',').length > 1) {
            return _.compact(value.split(','));
        } else if (value == 'true' || value == 'false') {
            return (value == 'true');
        } else {
            return value.replace('+', ' ');
        }
    }
    UrlParams.prototype.getParam = function (keyName) {
        var index = this.findIndexParam(keyName);

        return (index >= 0) ? this.params[index][keyName] : null;
    }
    UrlParams.prototype.findIndexParam = function (keyName) {
        return _.findIndex(this.params, function (param) {
            var keys = Object.keys(param);

            return keys[0] == keyName;
        });
    }
    UrlParams.prototype.getPathName = function () {
        return _.compact(document.location.pathname.split('/')).map(function (key) {
            return decodeURI(key);
        });
    }
    UrlParams.prototype.resetParams = function () {
        var href = Global.location.href.split('?')[0];

        this.params = [];
        history.pushState(null, null, href);
    }
    UrlParams.prototype.setParam = function (keyName, value) {
        var index = this.findIndexParam(keyName);
        var obj = {};
        var urlSplitted = Global.location.href.split('?');
        var href = urlSplitted[0];

        if (urlSplitted.length > 2) {
            href += urlSplitted[1];
        }

        obj[encodeURI(keyName)] = encodeURI(value);

        if (index >= 0) {
            this.params[index] = obj;
        } else {
            this.params.push(obj);
        }

        history.pushState(this.params, null, href + '?' + this.stringifyParams());
    }
    UrlParams.prototype.stringifyParams = function () {
        return this.params
            .filter(function (param) {
                var keyName = Object.keys(param)[0];

                return param[keyName] !== '';
            })
            .map(function (param) {
                var keyName = Object.keys(param)[0];

                return keyName + '=' + param[keyName];
            }).join('&');
    }

    Global.UrlParams = UrlParams;
}(window, jQuery, _));